// extracted by mini-css-extract-plugin
export default {"customerTitle":"ConfirmDeleteModal_customerTitle__oC3Jq","customerLabel":"ConfirmDeleteModal_customerLabel__pdP9+","customerBtn":"ConfirmDeleteModal_customerBtn__iob6R"};